export default __webpack_public_path__ + "files/61be9c9b7577676c05fa3acf37767507.png";